import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { IApplicationsStatus } from "@/types/applications";
var Chip = styled("span")({
    "display": "inline-flex",
    "alignItems": "center",
    "gap": "6px",
    "padding": "4px 12px 4px 8px",
    "borderRadius": "999px",
    "fontSize": "14px",
    "fontWeight": 600,
    "lineHeight": "20px",
    "whiteSpace": "normal",
    "maxWidth": "100%",
    "boxSizing": "border-box",
    "& svg": { fontSize: "18px", flexShrink: 0 },
    "&[data-status='PENDING']": {
        background: "#FFF3CD",
        border: "1px solid #F0D58C",
        color: "#7A5200",
    },
    "&[data-status='ACCEPTED']": {
        background: "#E7F8EF",
        border: "1px solid #A9E0C3",
        color: "#0B6B43",
    },
    "&[data-status='REJECTED']": {
        background: "#FDECEC",
        border: "1px solid #F5B5B5",
        color: "#B42318",
    },
});
var status = function (value) {
    var _a;
    return (_a = Object.values(IApplicationsStatus).find(function (candidate) { return candidate === (value !== null && value !== void 0 ? value : "").toUpperCase(); })) !== null && _a !== void 0 ? _a : IApplicationsStatus.PENDING;
};
/** Where an enrollment stands: needs review, approved or rejected. */
export var ApprovalStatusChip = function (props) {
    var t = useTranslation().t;
    var value = status(props.status);
    return (_jsxs(Chip, { "data-status": value, children: [value === IApplicationsStatus.ACCEPTED ? (_jsx(CheckCircleIcon, { "aria-hidden": true })) : value === IApplicationsStatus.REJECTED ? (_jsx(CancelIcon, { "aria-hidden": true })) : (_jsx(HourglassBottomIcon, { "aria-hidden": true })), t("approvalsScreen.status.".concat(value))] }));
};
/** What a rule does: approve automatically, send to a person or reject. */
export var ApprovalOutcomeChip = function (_a) {
    var decision = _a.decision;
    var t = useTranslation().t;
    var value = status(decision);
    return (_jsxs(Chip, { "data-status": value, children: [value === IApplicationsStatus.ACCEPTED ? (_jsx(CheckCircleIcon, { "aria-hidden": true })) : value === IApplicationsStatus.REJECTED ? (_jsx(CancelIcon, { "aria-hidden": true })) : (_jsx(PersonSearchIcon, { "aria-hidden": true })), t("approvalsScreen.matrix.decisions.".concat(value))] }));
};
